import { z } from 'zod'
import { ElevatorSurveyPartialSchema } from './elevator-survey'
import { FirestoreTimestamp } from './utils'

// Firestore document schema for storing complete ElevatorSurvey data
export const ElevatorSurveyDoc = z.object({
  surveyId: z.string(),
  unitId: z.string(),
  siteId: z.string(),

  // Complete survey data
  surveyData: ElevatorSurveyPartialSchema,

  // Submission metadata
  submittedBy: z.string(), // email of user who submitted
  submittedAt: FirestoreTimestamp,

  // Audit fields
  createdAt: FirestoreTimestamp,
  updatedAt: FirestoreTimestamp,

  // Modification audit (set when super admin edits survey answers)
  modifiedBy: z.string().optional(),
  modifiedAt: FirestoreTimestamp.optional(),

  // Status tracking
  // pending: Survey written to Firestore, awaiting processing
  // processed: Successfully processed and maintenance program generated
  // error: Processing failed
  status: z.enum(['pending', 'processed', 'error']).default('pending'),

  // Optional maintenance program reference
  generatedMaintenanceProgramId: z.string().nullable().optional(),
})

export type ElevatorSurveyDoc = z.infer<typeof ElevatorSurveyDoc>
